import styled from "styled-components";

const InitBiometricFooterSectionDefaultBox = styled.div`
  font-size: 1.25rem;
  color: ${({theme}) => theme.colors.textMiddleDark};
`;

export const InitBiometricFooterSectionBox = InitBiometricFooterSectionDefaultBox;